import Vue from 'vue';
import scroller from 'vue-scrollto';
import Router from 'vue-router';

import store from './store';
import Landing from './views/Landing.vue';
import Form from './views/Form.vue';
import Results from './views/Results.vue';
import About from './views/About.vue';
import easings from '@/utils/easings';

Vue.use(Router);

var router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/about',
            name: 'about',
            component: About
        },
        {
            path: '/results/:id',
            name: 'results',
            component: Results
        },
        {
            path: '/',
            name: 'landing',
            component: Landing
        },
        {
            path: '/form',
            name: 'form',
            component: Form
        },
        {
            path: '*',
            redirect: {
                path: '/'
            }
        }
    ]
});

router.beforeEach(function (to, from, next) {
    var started = false;

    scroller.scrollTo('body', {
        duration: 400,
        onStart: function () {
            started = true;
        },
        onDone: next,
        onCancel: next,
        easing: easings.inOutCubic
    });

    setTimeout(() => {
        if (!started) {
            next();
        }
    }, 0);
});

export default router;
